exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Tags-default-1g1E9{overflow:hidden}.Tags-default-1g1E9 label{margin:0;padding:10px 0;font-size:20px;font-weight:300;color:#546d79}.Tags-default-1g1E9 ul{margin:0;padding:0;list-style:none}.Tags-default-1g1E9 ul>li{display:inline-block;margin:10px 20px 10px 0}.Tags-default-1g1E9 ul>li.Tags-active-DVNDJ a{font-style:normal;color:#b0bec5}.Tags-default-1g1E9 ul>li a{display:inline-block;font-size:20px;font-weight:400;text-decoration:none;text-transform:lowercase;font-style:italic;color:#d3e2ea}.Tags-default-1g1E9 ul>li a:hover{color:#546d79}.Tags-default-1g1E9 ul>li a i{vertical-align:middle;margin:0 10px 0 0}", ""]);

// exports
exports.locals = {
	"default": "Tags-default-1g1E9",
	"active": "Tags-active-DVNDJ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/Tags.less
// module id = 1663
// module chunks = 0